import { createContext } from 'react';

export type RouterContextType = {
    strategy: 'WEB_APP' | 'FIGMA_PLUGIN'
}

export const RouterContext = createContext<RouterContextType>({
    strategy: 'WEB_APP'
})